import { useState } from "react";
import { HiOutlineChatAlt2, HiOutlineMail } from "react-icons/hi";
import MailHistory from "./MailHistory";
import SMSHistory from "./SmsHistory";

export default function MessageHistory() {
    const [activeTab, setActiveTab] = useState("sms");
    const baseUrl = process.env.REACT_APP_BASE_URL;

    const formatDate = (dateStr) => {
        const date = new Date(dateStr);

        const day = date.getUTCDate();
        const month = date.toLocaleString("en-US", { month: "short" });
        const year = date.getUTCFullYear();

        const weekday = date.toLocaleString("en-US", { weekday: "long" });

        let hours = date.getUTCHours();
        const minutes = date.getUTCMinutes().toString().padStart(2, "0");

        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12; // convert 0 → 12, 13 → 1

        return `${day} ${month}, ${year}, ${weekday}, ${hours}:${minutes} ${ampm}`;
    };

    const tabs = [
        { key: "sms", label: "SMS", icon: HiOutlineChatAlt2 },
        { key: "email", label: "Email", icon: HiOutlineMail },
    ];

    return (
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm">
            <div className="flex items-center justify-between px-4 pt-3 pb-2 border-b border-gray-100">
                <h1 className="text-[15px] font-semibold text-gray-800">
                    Message History
                </h1>

                <div className="inline-flex p-0.5 bg-gray-100 rounded-lg">
                    {tabs.map(({ key, label, icon: Icon }) => (
                        <button
                            key={key}
                            onClick={() => setActiveTab(key)}
                            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-[13px] font-medium transition-colors
                                ${activeTab === key
                                    ? "bg-white text-indigo-600 shadow-sm"
                                    : "text-gray-500 hover:text-gray-700"}`}
                        >
                            <Icon className="w-4 h-4" />
                            {label}
                        </button>
                    ))}
                </div>
            </div>

            <div className="p-4">
                {activeTab === "email" ? (
                    <MailHistory baseUrl={baseUrl} formatDate={formatDate} />
                ) : (
                    <SMSHistory baseUrl={baseUrl} formatDate={formatDate} />
                )}
            </div>
        </div>
    );
}